<template>
  <q-page class="q-pa-md" v-if="isReady">

    <div class="text-h6">
      Android app settings
    </div>
    <q-form @submit="saveProperties">

      <q-input label="Application name" v-model="properties.appName"/>
      <q-input label="Application bundle id" v-model="properties.bundleId"/>
      <media-picker :product-id="appId" media-type="image" label="Choose app icon" :module-id="moduleId" v-model="properties.appIcon"/>

      <media-picker :product-id="app_id" :module-id="module_id" media-type="android-creds" label="Signing key" v-model="properties.androidSigningKey"/>
      <q-input label="Signing key alias" v-model="properties.androidSigningKeyAlias"/>
      <q-input type="password" label="Signing key password" v-model="properties.androidSigningKeyPassword"/>

      <q-input label="The Firebase App ID, found in the Firebase console" v-model="properties.firebaseAppId"/>
      <q-input label="The API SECRET generated in the Google Analytics UI" v-model="properties.analyticsApiSecret"/>

      <!--media-picker :product-id="app_id" :module-id="module_id" media-type="android-creds" label="Google play deploy key" v-model="properties.googlePlayDeployKey"/!-->

      <q-separator/>
      <q-btn type="submit" label="Save" color="primary" class="q-mt-md"/>
    </q-form>

  </q-page>
</template>

<script>

import {integrationsMixin} from "@/pages/workspace/integrations/integrationsMixin";
import MediaPicker from "@/components/MediaGallery/MediaPicker.vue";

export default {
  components: {MediaPicker},
  mixins: [integrationsMixin],
  name: "AndroidIntegrationSettings",
  data: () => ({
    placement: {},
    appId: false
  }),

  created() {
    this.appId = this.$route.params.app_id || 0
    this.moduleId = this.$route.params.module_id || 0
  },

  computed: {

    /**
     * Return integration name
     */
    integration: () => ({name: "android", type: "os"}),
  }
}

</script>
